import type { Application, ApplicationPost } from '@/types/domain/apply';
import { applyRequestService } from '@/api/apply';

export const applicationsPost = (data: ApplicationPost) =>
    applyRequestService<Application>({
        url: '/applications',
        method: 'POST',
        data
    });
